import { useSSRContext } from 'vue';

import { isServer } from '@/helpers/platform';
import { type AppSSRContext } from '@/types';

const useConditionalSSRContext = (): AppSSRContext | null => {
  if (isServer()) {
    return useSSRContext() as AppSSRContext;
  }
  return null;
};

export default useConditionalSSRContext;
